import { render, staticRenderFns } from "./SkeletonGiftCard.vue?vue&type=template&id=e23eaa3e&scoped=true&"
import script from "./SkeletonGiftCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonGiftCard.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonGiftCard.vue?vue&type=style&index=0&id=e23eaa3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23eaa3e",
  null
  
)

export default component.exports